import React from "react";
import R14, {
  Text,
  View,
  FlatList,
  Platform,
} from "../core";
import Touchable from "./TouchableComponent";
import NoRecordsFound from "./NoRecordsFound";
import { commonStyles } from "../assets/css/commonStyle";
import { columnTableStyles } from "../assets/css/columnTableStyles";
import { commonFontStyles } from "../assets/css/commonFontStyles";
import { customCommonStyles } from "../assets/css/customCommonStyle";
import { responsiveTableStyle } from "../assets/css/responsiveTableStyle";
import DateUtils from "../utils/DateUtils";
import CommonUtility from "../utils/CommonUtility";
import ColumnPaginationComponent from "./ColumnPaginationComponent";

export default R14.connect(
  class SimpleMessageColumnTableComponent extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        rowsPerPage: this.props.rowsPerPage || 10,
        search: "",
        totalRows: 0,
        refreshing: false
      };
    }

    componentDidMount() {
      this.initializer();
    }

    async initializer(pageNo, searchTxt, isRefresh = false) {
      try {
        if (!isRefresh) {
          this.props.app.dm.userSession.setState({ isLoading: true });
        }
        const { page, rowsPerPage, search = null } = this.props;
        const gridState = { page: pageNo || page, rowsPerPage, search: searchTxt || search };
        await this.props.getPageData(gridState, { totalCount: true });
        this.setState({
          rowsPerPage: this.props.rowsPerPage || 10,
          search: searchTxt || search,
          refreshing: false
        });
        if (!isRefresh) {
          this.props.app.dm.userSession.setState({ isLoading: false });
        }
        return false;
      } catch (error) {
        this.setState({ refreshing: false });
        if (!isRefresh) {
          this.props.app.dm.userSession.setState({ isLoading: false });
        }
      }
    }

    shortenText = (txt = "", limit = 20) => {
      if (!!txt && !isNaN(txt) && !Number.isInteger(+txt)) {
        const num = +txt;
        return num.toFixed(2);
      } else if (!!txt && txt.length > limit) {
        return txt.substring(0, limit) + '...';
      } else {
        return txt;
      }
    };

    getNestedProperty(obj, path) {
      return path.split('.').reduce((acc, part) => acc && acc[part], obj);
    }

    onRefresh = () => {
      this.setState({ refreshing: true });
      this.initializer(1, this.state.search, true);
    }

    renderSimpleMessageTable(pageData, pagination, onProfileIcon) {
      const firstColumnCell = ["billerName", "subject", "lastMessage", "lastMessageDate"];
      const secondColumnCell = ["DETAILS"];
      const amountTypeFields = [];
      const dateTypeFields = ["lastMessageDate"];
      const firstColumnCellStatic = [];
      const secondColumnCellStatic = [];
      const buttonsList = ["DETAILS"];
      const boldCells = ["billerName", "lastMessage"];
      const onActionClick = onProfileIcon;
      return (
        <FlatList
          style={[
            columnTableStyles.flatListEle,
            pageData && pageData.length > 0 ? columnTableStyles.billListComponent : columnTableStyles.noItemsComponent,
            columnTableStyles.borderWidth0,
            commonStyles.marT0,
            commonStyles.marRT0,
            commonStyles.marLT0,
            commonStyles.positionRelative,
            !!pagination ? commonStyles.marginBottom16 : null,
          ]}
          data={ pageData || []}
          ListEmptyComponent={
            <View style={[commonStyles.flex1]}>
              <NoRecordsFound
                message={this.props.message}
              />
            </View>
          }
          onRefresh={this.onRefresh}
          refreshing={this.state.refreshing}
          keyExtractor={(el, i) => i}
          nestedScrollEnabled={true}
          scrollEnabled={true}
          bounces={true}
          showsVerticalScrollIndicator={false}
          showsHorizontalScrollIndicator={false}
          renderItem={({ item, index }) => (
            <View key={"tableRow_" + index} style={[columnTableStyles.flexRowWithBorder, commonStyles.wordBreakWord]}>
              {/* On icons before first key */}
              <View
                style={[
                  customCommonStyles.valueInMbileBreakWord,
                  commonStyles.wordBreakWord,
                  commonStyles.flex1,
                  // commonStyles.mView,
                  columnTableStyles.mViewIconContainer,
                  !!onProfileIcon ? null : commonStyles.displayNone,
                  commonStyles.flexDirectionColumn,
                ]}
              >
                {!!onProfileIcon && !!item[firstColumnCell[0]] ?
                  <Touchable onPress={() => onProfileIcon(item, "pro")}>
                    <View style={[responsiveTableStyle.userIconDiv, commonStyles.flex1, commonStyles.justifyContentCenter, commonStyles.alignItemsCenter, columnTableStyles.marginLeft0, commonStyles.marginTop5, commonStyles.marginRight5]}>
                      <Text
                        style={[
                          // commonMetricsStyle.heading6,
                          commonStyles.fontWeight500,
                          commonFontStyles.workSans,
                          commonStyles.smallHeading,
                          commonStyles.userInitial,
                          commonStyles.contentColor,
                          responsiveTableStyle.userInitial,
                          commonStyles.dBlock
                        ]}>
                        {CommonUtility.shortName(`${item[firstColumnCell[0]]}`)}
                      </Text>
                    </View>
                  </Touchable>
                  : null}
              </View>
              <View
                style={[
                  columnTableStyles.tr,
                  commonStyles.flex1,
                  commonStyles.justifyContentSpaceBetween,
                  commonStyles.flexDirectionColumn,
                  commonStyles.marLT0,
                  commonStyles.marRT0,
                  commonStyles.wordBreakWord,
                  commonStyles.flexDirectionRow
                ]}
              >
                <View style={[columnTableStyles.firstColumnCellWidth]}>
                  {firstColumnCell.map((value, idx) => (
                    <Touchable onPress={() => onProfileIcon(item, "pro")} key={"value_" + value + idx} style={[columnTableStyles.td, commonStyles.wordBreakWord, commonStyles.paddingRight16]}>
                      <View style={[commonStyles.wordBreakWord]}>
                        {value && item && this.simpleMessageCellRenderer(value, item, amountTypeFields, dateTypeFields, firstColumnCellStatic, buttonsList, boldCells, onActionClick)}
                      </View>
                    </Touchable>
                  ))}
                </View>
                <View style={[columnTableStyles.secondColumnCellWidth]}>
                  {secondColumnCell.map((value, idx) => (
                    <View key={"value_" + value + idx} style={[columnTableStyles.td, commonStyles.wordBreakWord, commonStyles.alignItemsEnd]}>
                      <View style={[commonStyles.wordBreakWord]}>
                        {value && item && this.simpleMessageCellRenderer(value, item, amountTypeFields, dateTypeFields, secondColumnCellStatic, buttonsList, boldCells, onActionClick,)}
                      </View>
                    </View>
                  ))}
                </View>
              </View>
            </View>
          )}
        />
      )
    }

    simpleMessageCellRenderer(columnName = "", row = [], amountTypeFields = [], dateTypeFields = [], columnCellStatic = [], buttonsList = [], boldCells = [], onActionClick, textOnly) {
      let text = row[columnName];
      if (buttonsList && buttonsList.length && row && buttonsList.includes(columnName)) {
        return (
          <Touchable style={[responsiveTableStyle.paynowBtn, columnTableStyles.btnHeight]} onPress={() => onActionClick(row)} >
            <View style={[responsiveTableStyle.paynowBtnInnerWrap, customCommonStyles.customPaynowBtnInnerWrap, Platform.OS !== "web" ? commonStyles.paddingTop3 : null,]}>
              <Text style={[commonFontStyles.workSans, commonStyles.fontWeight500, commonFontStyles.workSans, commonStyles.whiteColor, commonStyles.textAlignCenter, commonStyles.fullWidth, commonStyles.exSmallHeading, commonStyles.flex1, commonStyles.justifyContentCenter, commonStyles.alignItemsCenter, Platform.OS !== "web" ? commonStyles.marTMinus1 : null]}>{columnName}</Text>
            </View>
          </Touchable>
        );
      }

      if (!!amountTypeFields && amountTypeFields.length && amountTypeFields.includes(columnName)) {
        text = row[columnName] ? this.shortenText(CommonUtility.formatAmount(row[columnName], this.props.app)) : CommonUtility.formatAmount("0.00", this.props.app);
      } else if (!!dateTypeFields && dateTypeFields.length && dateTypeFields.includes(columnName)) {
        text = DateUtils.dataTableDateFormatter(row[columnName]);
      } else if (!!columnCellStatic && columnCellStatic.length && columnCellStatic.includes(columnName)) {
        text = columnName;
      }
      return <Text style={[commonFontStyles.workSans, columnTableStyles.cellText, columnTableStyles.nameCellNameText, boldCells.includes(columnName) ? commonStyles.fontWeight500 : commonStyles.fontWeight400]}>{this.shortenText(text)} </Text>
    }

    render() {
      const {
        containerStyle = null,
        onProfileIcon = null,
        pageData,
        totalRows,
        page,
        rowsPerPage,
      } = this.props;

      const pagination = totalRows > rowsPerPage;
      return (
        <View style={[columnTableStyles.container, commonStyles.flex1,  commonStyles.marginLtRt10, containerStyle]}>
          <View style={[columnTableStyles.table]}>
            {this.renderSimpleMessageTable(pageData, pagination, onProfileIcon)}

            {/* Pagination Starts */}
            {pageData && pageData.length && !!pagination ?
              <ColumnPaginationComponent
                initializer={(pageNo, searchTxt) => this.initializer(pageNo, searchTxt)}
                page={page}
                totalRows={totalRows}
                rowsPerPage={rowsPerPage}
              />
              : null}
          </View>
        </View>
      );
    }
  }
);
